/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric';
import FabricCanvasExercise, { Props } from '../fabricexercise';

// Stil sabitleri
const STYLES = {
  FONTS: {
    PRIMARY: '"Nunito", "Segoe UI", sans-serif' // Daha modern ve okunabilir font
  },
  COLORS: {
    CORRECT: {
      TEXT: '#2d7a3d', // Soft yeşil
      ICON: '#34a853' // Google yeşili
    },
    WRONG: {
      TEXT: '#d23f31', // Soft kırmızı
      ICON: '#ea4335', // Google kırmızısı
      STRIKE: '#b23f31' // Üstü çizili metin rengi
    },
    DEFAULT: '#333333' // Normal metin rengi
  },
  FONT_SIZES: {
    NORMAL: 24,
    SMALL: 22,
    SMALLER: 14,
    ICON: 12
  }
};

class OpenEnd extends FabricCanvasExercise {
  private options: any[] = []; // Kaynak veriler
  private textboxes: any[] = []; // Textbox nesneleri

  configureCanvas(props: Props): void {
    const canvas = this._canvas;

    // Mevcut tüm Textbox'ları kaldır
    this.textboxes.forEach((textbox) => canvas.removeObject(textbox));
    this.textboxes = [];
    // Yeni Textbox'ları oluştur ve ekle
    if (props.currentPageItem.sources) {
      this.options = props.currentPageItem.sources;
    }
    const minHeight = this.options.reduce((min, item) => {
      return item.height < min ? item.height : min;
    }, Infinity);
    const imageCoordinate = this._canvas.getBackgroundImageCoordinate();
    this.options.forEach((option) => {
      const left = imageCoordinate.imgLeft + option.x;
      const top = imageCoordinate.imgTop + option.y;
      const width = option.width;
      const height = option.height;

      // Dikdörtgen arka plan
      const rect = new fabric.Rect({
        left,
        top,
        width,
        height,
        fill: 'rgba(122, 119, 119, 0.45)',
        selectable: false,
        hasControls: false,
        lockMovementX: true,
        lockMovementY: true,
        erasable: false,
      });

      // Textbox
      const textbox = new fabric.Textbox('', {
        left,
        top,
        width,
        height,
        fontSize: minHeight,
        pageIcon: true,
        fill: '#000',
        textAlign: 'center',
        optionId: option.id,
        hasControls: false,
        lockMovementX: true,
        lockMovementY: true,
        selectable: true,
        erasable: false,
        editable: true,
      });
      textbox.on('mousedown', () => {
  
      });
      // Dikdörtgeni ve textbox'ı ekle
      canvas.addObject(rect);
      canvas.addObject(textbox);
      canvas.bringToFront(textbox);

      this.textboxes.push(textbox);
    });

    canvas.canvasRenderAll();
  }

  onShowAnswer = async () => {
    const options = this.options;
    const inputs = this.textboxes;
    for (const input of inputs) {
      const option = options.find(
        (x) => Number(x.id) === Number(input.optionId)
      )
      input.set({
        text: option.correctAnswer.trim(),
      });
      this.addOpenedAnswers(option.id)
    }
    this._canvas.canvasRenderAll();
  }

  onComplete = (): {
    userAnswer: string;
    correctAnswer: string;
    status: string;
  }[] => {
    const results: {
      userAnswer: string;
      correctAnswer: string;
      status: string;
    }[] = [];

    this.textboxes.forEach((textbox, index) => {
      const userAnswer = textbox.text?.trim() || '';
      const correctAnswer = this.options[index].correctAnswer.trim();
      const status = userAnswer.toLowerCase() === correctAnswer.toLowerCase() ? 'Correct' : 'Wrong';

      results.push({ userAnswer, correctAnswer, status });

      // İkon için dikey merkez hesaplama
      const centerY = textbox.top + (textbox.height / 2);

      if (status === 'Correct') {
        textbox.set({
          fill: STYLES.COLORS.CORRECT.TEXT,
          fontSize: STYLES.FONT_SIZES.NORMAL,
          fontFamily: STYLES.FONTS.PRIMARY
        });

        const tick = new fabric.Group([
          new fabric.Circle({
            radius: 8,
            fill: STYLES.COLORS.CORRECT.ICON
          }),
          new fabric.Text('✓', {
            fontSize: STYLES.FONT_SIZES.ICON,
            fontWeight: 'bold',
            fill: 'white',
            fontFamily: STYLES.FONTS.PRIMARY,
            left: 3,
            top: 2
          })
        ], {
          left: textbox.left - 10,
          top: centerY - 4,
          originY: 'center'
        });

        this._canvas.addObject(tick);

      } else {
        this._canvas.removeObject(textbox);

        const container = new fabric.Group([
          // Doğru cevap - biraz küçük
          new fabric.Text(correctAnswer, {
            left: 0,
            top: 0,
            width: textbox.width,
            fontSize: STYLES.FONT_SIZES.SMALL, // Biraz küçük
            fill: STYLES.COLORS.CORRECT.TEXT,
            textAlign: 'left',
            fontFamily: STYLES.FONTS.PRIMARY
          }),
          // Yanlış cevap - daha küçük
          ...(userAnswer ? [
            new fabric.Text(userAnswer, {
              left: 0,
              top: STYLES.FONT_SIZES.SMALL + 4, // Doğru cevaptan sonra uygun boşluk
              width: textbox.width,
              fontSize: STYLES.FONT_SIZES.SMALL, // En küçük boyut
              fill: STYLES.COLORS.WRONG.TEXT,
              textAlign: 'left',
              fontFamily: STYLES.FONTS.PRIMARY,
              linethrough: true,
              strokeWidth: 1,
              stroke: STYLES.COLORS.WRONG.STRIKE
            })
          ] : [])
        ], {
          left: textbox.left,
          top: textbox.top + (textbox.height - STYLES.FONT_SIZES.NORMAL) / 4, // Dikey hizalama
          width: textbox.width,
          height: textbox.height,
          selectable: false,
          evented: false
        });

        const cross = new fabric.Group([
          new fabric.Circle({
            radius: 8,
            fill: STYLES.COLORS.WRONG.ICON
          }),
          new fabric.Text('✕', {
            fontSize: STYLES.FONT_SIZES.ICON,
            fontWeight: 'bold',
            fill: 'white',
            fontFamily: STYLES.FONTS.PRIMARY,
            left: 3,
            top: 2
          })
        ], {
          left: textbox.left - 10,
          top: centerY - 4,
          originY: 'center'
        });

        this._canvas.addObject(container);
        this._canvas.addObject(cross);
      }
    });

    this._canvas.canvasRenderAll();
    return results;
  };

  onReset = (): void => {
    this.resetOpenedAnswers();

    // Tüm eklenen objeleri temizle
    const canvas = this._canvas;
    const objects = canvas.getObjects();
    const itemsToRemove = objects.filter(obj =>
      obj.type === 'group' ||
      (obj.type === 'text' && obj.fill !== '#000')
    );

    itemsToRemove.forEach(item => canvas.removeObject(item));

    // Textboxları sıfırla
    this.textboxes.forEach((textbox) => {
      textbox.set({
        text: '',
        fill: '#000',
        fontSize: 20
      });
    });

    canvas.canvasRenderAll();
  };

  doMouseDown(o: any): void {}

  doMouseMove(o: any): void {}

  doMouseUp(o: any) {
    const canvas = this._canvas;
    const objects = canvas.getObjects().filter((x) => x.pageIcon);
    objects.forEach((obj) => {
      canvas.bringToFront(obj);
    });
    canvas.canvasRenderAll();
  }

  onShowPreviousAnswer = async () => {
    const canvas = this._canvas;
    const showedItems = this.options.filter(
      (x) => this.getOpenedAnswers().includes(x.id)
    )
    if (showedItems.length > 0) {
      const inputs = canvas.getObjects().filter((x) => x.pageIcon);
      const item = showedItems[showedItems.length - 1]
      const input = Array.from(inputs).find(
        (x) => Number(item.id) === Number(x.optionId)
      )
      if(input){
        input.set({
          text: '',
        });
      }

      canvas.canvasRenderAll();
      this.removeOpenedAnswers(item.id)
    }
  }

  onShowNextAnswer = async () => {
    const canvas = this._canvas;
    const notShowedItems = this.options.filter(
      (x) => !this.getOpenedAnswers().includes(x.id)
    )
    if (notShowedItems.length > 0) {
      const inputs = canvas.getObjects().filter((x) => x.pageIcon);
      const option = notShowedItems[0]
      const input = Array.from(inputs).find(
        (x) => Number(x.optionId) === Number(option.id)
      )
      if(input){
        input.set({
          text: option.correctAnswer,
        });
      }
      canvas.canvasRenderAll();
      this.playSound('solve')
      this.addOpenedAnswers(option.id)
    }
  }
  destroy(): void {
    this.resetOpenedAnswers();
    this._canvas.off('after:render');
    const elements = document.getElementsByClassName('openend-input');
    while (elements.length > 0) {
      elements[0].remove();
    }
  }
}

export default OpenEnd;
